import { Link } from "react-router-dom";
import { Receipt, CurrencyEur } from "@phosphor-icons/react";

const TABS = [
  { key: "preventivi", to: "/preventivi", label: "Preventivi", icon: Receipt },
  { key: "avvisi", to: "/fatturazione", label: "Avvisi di Notula", icon: CurrencyEur },
];

/** Schede in cima a Preventivi e Avvisi: sono la stessa area di lavoro (l'avviso nasce dal preventivo). */
export function TabsPreventiviAvvisi({ attiva }) {
  return (
    <div className="inline-flex rounded-lg bg-slate-100 p-1 mb-4" data-testid="tabs-preventivi-avvisi">
      {TABS.map(({ key, to, label, icon: Icon }) => (
        <Link key={key} to={to} className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-md text-sm transition-colors ${attiva === key ? "bg-white shadow font-semibold text-slate-900" : "text-slate-600 hover:text-slate-900"}`} data-testid={`tab-${key}`}>
          <Icon size={15} /> {label}
        </Link>
      ))}
    </div>
  );
}
